/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
/*
 * @author Sergey Kuzhavskiy <Praffesor>
 */
angular.module('public.security-manager.client.show').directive('gccsClientShowDocumentsHeader', () =>
  ({
    restrict: 'A',
    controller: 'ClientShowDocumentsHeaderController',
    controllerAs: 'clientShowDocumentsHeaderCtrl',
    template: require('./template.pug'),
    scope: {
      nameOrderParam: '='
    }
  })
);
